{  
    "accountnumber": "Account Number",
    "routingnumber": "Routing Number",
    "institutionname": "Institution Name",
    "institutionaddressline": "Institution Address",
    "institutioncountry": "Country",
    "institutioncity": "Institution City",
    "institutionzipcode": "Institution Zip Code",
    "holdername": "Holder Name",
    "holderaddress": "Holder Address",
    "holderzipcode": "Holder Zip Code",
    "holdercity": "Holder City",
    "swiftbic": "Swift BIC",
    "memo": "MEMO",
    "memoinstructions": "Use MEMO code to receive funds faster",
    "address": "Address",
    "blockchain": "Blockchain",
    "network": "Network",
    "cryptodeposit": "Crypto Deposit Info",
    "walletaddress": "Wallet Address"
}